import { Frame, Status } from 'features/Frames/types';

const CSV_HEADER =
  'frame_id,name,display_unit_id,broadsign_frame_id,publisher,environment,format_size,resolution,status,status_time';
const HEADERS = [
  'id',
  'name',
  'displayUnitId',
  'broadsignFrameId',
  'publisher',
  'environment',
  'formatSize',
  'resolution',
  'status',
];

const frameToStringArray = (frame: Frame) =>
  HEADERS.map((header) => {
    const frameDetail = frame[header as keyof Frame];
    if (header === 'status') {
      const frameStatus = frameDetail as Status;
      return `"${frameStatus.state}","${frameStatus.time}"`;
    }
    return `"${frameDetail}"`;
  });

export const framesCsvBody = (status: string, frames: Frame[]) => {
  const csvRows = [];

  for (const frame of frames) {
    if (frame.status?.state === status) {
      const frameDetailsStringArray = frameToStringArray(frame);
      const frameDetailsCsvString = frameDetailsStringArray.join(',');
      csvRows.push(frameDetailsCsvString);
    }
  }
  const csvData = csvRows.join('\n');
  return `${CSV_HEADER}\n${csvData}`;
};
